'use client'

import { Builder, withChildren } from '@builder.io/react'

import { VideoPlayer } from './VideoPlayer'

Builder.registerComponent(withChildren(VideoPlayer), {
  name: 'Video Player',
  defaultChildren: [],
  inputs: [
    {
      name: 'videoId',
      friendlyName: 'Video ID',
      type: 'string',
      defaultValue: '5582588664001',
      helperText: 'Brightcove Video ID',
    },
    {
      name: 'width',
      friendlyName: 'Player Width',
      type: 'number',
      defaultValue: 0,
      helperText: 'Set 0 for Responsive Player size',
    },
    {
      name: 'playAsPopup',
      friendlyName: 'Play Video in Popup Modal',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'autoplay',
      friendlyName: 'AutoPlay video on load',
      type: 'boolean',
      defaultValue: false,
    },
  ],

  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/player-play.svg',
})
